import { DependencyList, RefObject, useEffect, useState } from 'react'

export const useScrollbarPresence = <T extends HTMLElement>(
  ref: RefObject<T | null>,
  dependencies: DependencyList = []
) => {
  const [hasScrollbar, setHasScrollbar] = useState(false)

  useEffect(() => {
    const node = ref.current

    if (!node) {
      setHasScrollbar(false)
      return
    }

    const updateScrollbarState = () => {
      const nextHasScrollbar = node.scrollHeight > node.clientHeight
      setHasScrollbar((prev) =>
        prev !== nextHasScrollbar ? nextHasScrollbar : prev
      )
    }

    updateScrollbarState()

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(updateScrollbarState)
      observer.observe(node)

      return () => {
        observer.disconnect()
      }
    }

    if (typeof window === 'undefined') {
      return
    }

    const handleResize = () => updateScrollbarState()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [ref, ...dependencies])

  return hasScrollbar
}
